import { LocaleBundle } from "../types";

const de: LocaleBundle = {
  "ui": {
    "nav": {
      "features": "Funktionen",
      "pricing": "Preise",
      "integrations": "Integrationen",
      "industries": "Branchen",
      "apiDocs": "Dokumentation",
      "about": "Über uns",
      "customers": "Kunden",
      "contact": "Kontakt",
      "login": "Anmelden",
      "getFreeCRM": "FreeCRM nutzen",
      "openMenu": "Menü öffnen",
      "language": "Sprache"
    },
    "hero": {
      "badge": "Das Multi-Channel CRM: E-Mail, Telefon & SMS",
      "titleStart": "Das CRM für ",
      "titleHighlight": "Multi-Channel-Vertriebsteams",
      "subtitle": "Erreichen Sie jeden Kunden dort, wo er sich aufhält – mit integriertem E-Mail-Marketing, Telefonie und SMS in einer Plattform. Keine Add-ons, kein Enterprise-Preisschild.",
      "cta": "Kostenlos starten — keine Kreditkarte erforderlich",
      "pills": [
        "E-Mail-Marketing",
        "Telefonie & Anrufe",
        "Zwei-Wege-SMS"
      ],
      "iosApp": "iOS App",
      "androidApp": "Android App",
      "heroAlt": "FreeCRM Dashboard mit Deal-Pipeline und Kontaktmanagement"
    },
    "logos": {
      "trustedBy": "Vertraut von über 25.000 wachsenden Teams"
    },
    "features": {
      "eyebrow": "Funktionen",
      "title": "Ein CRM. Jeder Kanal, den Ihre Kunden nutzen.",
      "subtitle": "E-Mail-Marketing, Telefonie und SMS in einer Plattform – damit Ihr Team potenzielle Kunden so erreichen kann, wie diese es bevorzugen.",
      "items": [
        {
          "title": "E-Mail-Marketing",
          "desc": "Gestalten Sie Kampagnen, versenden Sie Broadcasts und pflegen Sie Leads mit Sequenzen – alles aus demselben Kontaktdatensatz heraus."
        },
        {
          "title": "Telefonie & Anrufe",
          "desc": "Click-to-Call, Anrufprotokollierung und -aufzeichnung sind direkt integriert. Eingehende Anrufe sind inklusive programmierbarer Mailbox — verbinden Sie Ihre Nummer und starten Sie sofort Gespräche."
        },
        {
          "title": "Zwei-Wege-SMS",
          "desc": "Texten Sie Leads und Kunden aus dem gleichen Posteingang. Vorlagen, geplante Versendungen und der vollständige Gesprächsverlauf sind inklusive."
        },
        {
          "title": "Multi-Channel-Sequenzen",
          "desc": "Kombinieren Sie E-Mail, SMS und Anrufe in einer Kampagne. Erreichen Sie jeden Interessenten über den Kanal, auf den er tatsächlich reagiert."
        },
        {
          "title": "Vereinheitlichte Analysen",
          "desc": "Verfolgen Sie Öffnungen, Klicks, Antworten, Verbindungen und Konversionen über jeden Kanal in einem Dashboard."
        },
        {
          "title": "Automatisierung",
          "desc": "Registrieren Sie Leads automatisch für Kampagnen, wechseln Sie diese zwischen Vertriebsmitarbeitern und lösen Sie Folgemaßnahmen basierend auf jedem Signal aus."
        },
        {
          "title": "Terminplanung",
          "desc": "Teilen Sie öffentliche Buchungslinks mit mehreren Termintypen. Die Kalendersynchronisation hält die Verfügbarkeit aktuell und Videokonferenz-Links werden automatisch für jedes Meeting generiert."
        },
        {
          "title": "Integrationen",
          "desc": "Verbinden Sie Google, Microsoft 365, DocuSign, QuickBooks, Zapier und Videokonferenzen mit Zoom, Google Meet und Zoho Meeting, um Ihre Daten synchron zu halten und Workflows in den Tools zu automatisieren, die Sie bereits nutzen."
        },
        {
          "title": "KI-gestütztes CRM",
          "desc": "Lassen Sie die KI E-Mail-Antworten entwerfen, nächste Schritte vorschlagen, Konversationen zusammenfassen und jeden Deal voranbringen — damit Ihr Team weniger schreibt und mehr verkauft."
        }
      ]
    },
    "testimonials": {
      "eyebrow": "Kunden",
      "title": "Vertraut von Multi-Channel-Vertriebsteams",
      "items": [
        {
          "quote": "Wir haben drei Tools – E-Mail-Marketing, Dialer und CRM – durch FreeCRM ersetzt. Unser Team führt jetzt Kampagnen über E-Mail, SMS und Anrufe von einem Ort aus durch.",
          "name": "Maya Chen",
          "role": "VP Sales, B2B SaaS"
        },
        {
          "quote": "Multi-Channel-Sequenzen haben alles verändert. Die Kombination von E-Mail, SMS und einem Anruf in einer Kampagne hat unsere Antwortrate verdoppelt, ohne zusätzliches Personal.",
          "name": "Daniel Okafor",
          "role": "Verkaufsleiter, Apex Solutions"
        },
        {
          "quote": "Wir sind von HubSpot zu FreeCRM gewechselt und haben endlich E-Mail-Marketing, Telefonie und SMS in einer Plattform – ohne Integrationskosten.",
          "name": "Priya Raman",
          "role": "COO, Brightline"
        }
      ]
    },
    "pricing": {
      "eyebrow": "Preise",
      "title": "CRM-Software-Preise",
      "subtitle": "US-Telefonnummern nur $1.15/Monat · $0.01 pro Minute · $0.01 pro SMS",
      "mostPopular": "Am beliebtesten",
      "perUserMo": "/Benutzer/Monat",
      "tiers": [
        {
          "name": "Kostenlos",
          "price": "$0",
          "blurb": "Dauerhaft kostenlos mit E-Mail, Telefonie & SMS integriert.",
          "cta": "Kostenlos anmelden"
        },
        {
          "name": "Pro",
          "price": "$10",
          "blurb": "Volle CRM-Power für wachsende Vertriebsteams.",
          "cta": "Anmelden"
        },
        {
          "name": "Enterprise",
          "price": "$25",
          "blurb": "Erweiterte Funktionen für Teams mit hohem Volumen.",
          "cta": "Anmelden"
        }
      ],
      "sharedFeatures": [
        "Unbegrenzter Speicherplatz",
        "Kontakte & Unternehmen",
        "Deals & Aufgaben",
        "Fälle & Anrufe",
        "Kalender & Dokumente",
        "Berichte",
        "iOS & Android Apps",
        "Kampagnen & Formulare",
        "E-Mail",
        "API-Zugang",
        "Google Synchronisierung",
        "QuickBooks",
        "SMS",
        "Sprachanrufe",
        "Kreditkarte"
      ]
    },
    "faq": {
      "eyebrow": "Häufig gestellte Fragen",
      "title": "Fragen, beantwortet",
      "items": [
        {
          "q": "Ist FreeCRM wirklich kostenlos für E-Mail, Telefonie und SMS?",
          "a": "Ja – der kostenlose Plan beinhaltet E-Mail-Marketing, Click-to-Call, Anrufprotokollierung und 500 SMS-Nachrichten pro Monat ohne Kosten. Bezahlte Tarife schalten höhere Sendelimits, erweiterte Automatisierung, Anrufaufzeichnung und unbegrenzte SMS frei."
        },
        {
          "q": "Wie unterscheidet sich FreeCRM von HubSpot?",
          "a": "Im Gegensatz zu HubSpot sind alle Kanäle nativ – E-Mail-Marketing, Telefonie und SMS sind alle inklusive, nicht als separate Add-ons oder kostspielige Integrationen erhältlich."
        },
        {
          "q": "Kann ich E-Mail-Kampagnen und -Sequenzen durchführen?",
          "a": "Ja. Entwerfen Sie Broadcasts, Drip-Kampagnen und mehrstufige Sequenzen, die E-Mail, SMS und Anrufe kombinieren – mit vollständiger Verfolgung von Öffnungen, Klicks und Antworten."
        },
        {
          "q": "Wie funktioniert die Telefonie in FreeCRM?",
          "a": "Anrufe laufen direkt in Ihrem Browser — kein separates Telefon oder Dialer erforderlich. Tätigen Sie ausgehende Anrufe per Click-to-Call, empfangen Sie eingehende Anrufe auf Ihrer FreeCRM-Nummer und leiten Sie sie an den richtigen Mitarbeiter weiter. Die programmierbare Voicemail mit individuellen Begrüßungen und automatischer Transkription fängt jeden verpassten Anruf ab."
        },
        {
          "q": "Unterstützen Sie Zwei-Wege-SMS?",
          "a": "Ja. Senden und empfangen Sie SMS aus demselben Posteingang wie Ihre E-Mails, mit Vorlagen, geplanten Verssendungen und vollständigem Gesprächsverlauf pro Kontakt."
        }
      ]
    },
    "cta": {
      "title1": "E-Mail, Telefonie und SMS in einem CRM.",
      "title2": "Erreichen Sie Kunden auf jedem Kanal.",
      "subtitle": "Schließen Sie sich über 25.000 Teams an, die FreeCRM für E-Mail-Marketing, Telefonie und SMS nutzen – alles auf einer kostenlosen, Multi-Channel-Plattform.",
      "button": "Kostenlos starten"
    },
    "footer": {
      "tagline": "Das kostenlose CRM, das mit Ihrem Unternehmen wächst.",
      "copyright": "Alle Rechte vorbehalten.",
      "tagBuiltFor": "Gebaut für Teams, die etwas Besseres als HubSpot verdienen.",
      "cols": {
        "product": "Produkt",
        "company": "Unternehmen",
        "resources": "Ressourcen",
        "legal": "Rechtliches"
      },
      "links": {
        "features": "Funktionen",
        "pricing": "Preise",
        "integrations": "Integrationen",
        "industries": "Branchen",
        "changelog": "Changelog",
        "about": "Über uns",
        "customers": "Kunden",
        "careers": "Karriere",
        "contact": "Kontakt",
        "blog": "Blog",
        "helpCenter": "Hilfe-Center",
        "apiDocs": "Dokumentation",
        "community": "Community",
        "privacy": "Datenschutz",
        "terms": "Nutzungsbedingungen",
        "security": "Sicherheit",
        "dpa": "Datenverarbeitungsvertrag"
      }
    },
    "contentPage": {
      "readyToStart": "Bereit, anzufangen?",
      "joinThousands": "Schließen Sie sich Tausenden von Teams an, die FreeCRM nutzen, um E-Mail-Marketing, Telefonie, SMS und die Pipeline zu optimieren.",
      "defaultCta": "Kostenlos starten — keine Kreditkarte erforderlich",
      "learnMore": "Mehr erfahren →"
    },
    "languageNames": {
      "en": "Englisch",
      "es": "Spanisch",
      "fr": "Französisch",
      "pt": "Portugiesisch",
      "it": "Italienisch", "de": "Deutsch", "ar": "Arabisch"
    }
  },
  "featurePages": {
    "calling": {
      "title": "Integrierte Telefonie",
      "eyebrow": "Funktion",
      "description": "Click-to-Call, eingehende Anrufe mit programmierbarer Mailbox, Browservanrufe, virtuelle Nummern, Aufzeichnung und Power Dialer – alles in FreeCRM integriert.",
      "intro": "Callcenter-CRM-Lösungen von FreeCRM automatisieren Inbound- und Outbound-Telefonie in 90 Ländern. Eingehende Anrufe sind inklusive programmierbarer Mailbox — holen Sie sich eine virtuelle Nummer oder nutzen Sie Ihre eigene Mobilnummer, und beginnen Sie sofort mit dem Anwählen aus jedem Kontaktdatensatz.",
      "sections": [
        {
          "heading": "Click-to-Call von überall",
          "body": "Erfahren Sie, warum wir das #1 kostenlose CRM für Vertriebsautomatisierung, Marketing und Kundenservice sind – mit Click-to-Call Browservanrufen zu jeder Telefonnummer, von jedem Kontakt-, Deal- oder Unternehmensdatensatz aus."
        },
        {
          "heading": "Aufzeichnung, Planung & Gruppenanrufe",
          "body": "Zeichnen Sie Anrufe für Coaching und Compliance auf, planen Sie Folgemaßnahmen, führen Sie Gruppenanrufe durch und senden Sie SMS – alles innerhalb des CRM ohne zusätzliche Tools."
        },
        {
          "heading": "Eingehende Anrufe & programmierbare Mailbox",
          "body": "Jede FreeCRM-Nummer empfängt eingehende sowie ausgehende Anrufe — ohne Zusatzkosten. Leiten Sie Anrufe an den richtigen Mitarbeiter weiter, legen Sie Geschäftszeiten fest und konfigurieren Sie eine programmierbare Mailbox mit individuellen Begrüßungen und automatischer Transkription, damit keine Nachricht verloren geht."
        },
        {
          "heading": "Power Dialer & Anrufskripte",
          "body": "Maximieren Sie die Effektivität mit bestehenden Kunden und Interessenten. Leistungsstarke Anrufskripte und Automatisierung führen zu zuverlässigen Verkaufsresultaten und helfen Ihnen, Ihren Gewinn zu steigern."
        },
        {
          "heading": "Kampagnen & Nachfassaktionen",
          "body": "Erstellen Sie Anruf- und SMS-Kampagnen, automatisieren Sie Anrufe und SMS und organisieren und planen Sie Ihre Nachfassaktionen, damit nichts übersehen wird."
        }
      ]
    },
    "contacts": {
      "title": "Kontakte & Lead-Management",
      "eyebrow": "Funktion",
      "description": "Unbegrenzte Kontakte, benutzerdefinierte Felder und leistungsstarker Import von Outlook, Salesforce, HubSpot oder Zoho.",
      "intro": "Kontakte sind Ihre Interessenten, Leads und Kunden – Lieferanten, Partner, Spender. In FreeCRM sind Ihre Kontakte Gold wert, und so behandeln wir sie auch.",
      "sections": [
        {
          "heading": "Alles anpassen",
          "body": "Fügen Sie so viele benutzerdefinierte Felder hinzu, wie Sie benötigen. Jedes Unternehmen benötigt ein maßgeschneidertes CRM – mit FreeCRM können Sie Kontaktblätter, Formulare und jeden Teil des Systems anpassen."
        },
        {
          "heading": "Jede Interaktion verfolgen",
          "body": "Verfolgen und verwalten Sie Beziehungen, Anrufe und Besprechungen. Verknüpfen Sie Dokumente, Besprechungs- und Anrufnotizen sowie andere wichtige Informationen mit den Personen, für und mit denen Sie arbeiten."
        },
        {
          "heading": "B2B, B2C und mehr",
          "body": "Kontakte sind Einzelpersonen, die Unternehmen oder anderen Organisationen angehören können. Wir unterstützen B2B, B2C und komplexere Geschäftsmodelle."
        },
        {
          "heading": "Importieren von überall",
          "body": "Importieren Sie Kontaktlisten aus jeder Tabellenkalkulationsdatei, Outlook, Salesforce, HubSpot, Zoho oder jeder anderen Kontaktmanagement-Software."
        }
      ]
    },
    "companies": {
      "title": "Unternehmen & Accounts",
      "eyebrow": "Funktion",
      "description": "Verfolgen Sie Organisationen, Lieferanten und Partner mit benutzerdefinierten Feldern, Listen und einer gemeinsamen Aktivitätshistorie.",
      "intro": "Die FreeCRM Unternehmensliste bietet eine robuste, flexible Organisationsverfolgung für jede Entität – B2B, B2C, gemeinnützig oder staatlich – mit vollständig anpassbaren Feldern.",
      "sections": [
        {
          "heading": "Organisieren und teilen",
          "body": "Organisieren Sie nach Kategorie, Status, Priorität oder benutzerdefinierten Filtern. Importieren und exportieren Sie Listen sofort, erstellen Sie unbegrenzt viele Listen und teilen Sie Organisationsinformationen innerhalb Ihres Teams."
        },
        {
          "heading": "Alle Aktivitäten an einem Ort",
          "body": "Verkaufsgespräche, Störungstickets und Kundenaktivitäten werden verfolgt und gemeldet. E-Mail-Kampagnen und Anrufautomatisierungs-Tracking werden nach Unternehmen organisiert."
        },
        {
          "heading": "Warum Unternehmen?",
          "body": "Durch die Verfolgung der Unternehmen, mit denen Sie Geschäfte tätigen, können Ihre Teams effektivere Verkaufskampagnen orchestrieren und Chancen innerhalb Ihrer Organisation identifizieren und teilen."
        }
      ]
    },
    "deals": {
      "title": "Deal-Pipeline",
      "eyebrow": "Funktion",
      "description": "Visuelle Sales-Pipeline, Statusverfolgung, Prognosen und Berichte – entwickelt für Outbound-Vertriebsteams.",
      "intro": "Deals sind der Grund, warum Sie hier sind. Die FreeCRM Deal-Funktion ermöglicht es Ihnen, Leads zu verwalten und zu verfolgen und dabei fundierte Verkaufsmethoden anzuwenden, um Ihr Geschäft auf die nächste Stufe zu heben.",
      "sections": [
        {
          "heading": "Stufenverfolgung",
          "body": "Deals werden anhand ihres Status verfolgt – Angebot, Schätzung, Bestellung, Rechnung, Provision – damit Sie immer wissen, wo jede Opportunity steht."
        },
        {
          "heading": "Berichte & Prognosen",
          "body": "Die Pipeline liefert Tabellen, Berichte und Diagramme, die zeigen, wie Ihr Vertriebsteam und Ihre Kampagnen abschneiden. Quantifizieren Sie den Erfolg über die Zeit und identifizieren Sie neue Chancen bei neuen oder bestehenden Kunden."
        },
        {
          "heading": "Team-Zusammenarbeit",
          "body": "Die Verfolgung von Deals schafft Zusammenhalt bei den Personen, die Ihren Vertrieb unterstützen. Services und Support können während des gesamten Zyklus zusammenarbeiten, um den Teamerfolg zu demonstrieren und zu erzielen."
        }
      ]
    },
    "tasks": {
      "title": "Aufgabenverwaltung",
      "eyebrow": "Funktion",
      "description": "Aufgaben priorisieren, zuweisen und verfolgen – mit Workflow und Status – über Deals, Kontakte und Fälle hinweg.",
      "intro": "Die Verfolgung von Aufgaben, Problemen und Verkäufen bietet Ihnen vollständige Transparenz über die Zeit, die Sie und Ihr Team für jeden Deal oder jedes Problem aufwenden.",
      "sections": [
        {
          "heading": "Aufgaben verwalten!",
          "body": "Priorisieren Sie Aufgaben, erstellen Sie benutzerdefinierte Aufgabentypen, die spezifisch für Ihr Unternehmen sind, weisen Sie Aufgaben Teammitgliedern oder Mitarbeitern zu, geben Sie ihnen Workflow und Status und delegieren Sie die Arbeitslast innerhalb Ihres Teams."
        },
        {
          "heading": "Ein besserer Delegierer",
          "body": "Da Sie Aufgaben zuweisen können, werden Sie sofort zu einem besseren Delegierer, ohne die Qualität und den Service, den Ihr Team liefert, aus den Augen zu verlieren."
        }
      ]
    },
    "cases": {
      "title": "Fallmanagement",
      "eyebrow": "Funktion",
      "description": "Tickets öffnen, Probleme weiterleiten, Status und Prioritäten anpassen und jeden Kundenfall lösen.",
      "intro": "Die Fall- und Problemerfassung bietet 100% Transparenz über die Probleme, die Sie für Kunden, Lieferanten und Partner lösen.",
      "sections": [
        {
          "heading": "Virtueller Helpdesk",
          "body": "Starten Sie einen neuen Fall und öffnen Sie ein Ticket in Ihrem virtuellen Helpdesk. Verknüpfen Sie langfristige Fälle mit laufenden Problemen, die schnell gelöst und geschlossen werden können."
        },
        {
          "heading": "An Ihr Team anpassen",
          "body": "Passen Sie Support-Anfragen mit benutzerdefinierten Feldern an, weisen Sie Probleme einem oder mehreren Teammitgliedern zu und verfolgen Sie jeden Fall, sodass kein Kundenproblem übersehen wird."
        },
        {
          "heading": "Alles verbinden",
          "body": "Verknüpfen Sie Fälle mit Unternehmen, Kontakten, Anrufen, Ereignissen oder Dokumenten. Fügen Sie Notizen hinzu, während das Problem fortschreitet, und bewahren Sie alle Informationen in einem praktischen Fall auf."
        }
      ]
    },
    "campaigns": {
      "title": "Marketing-Automatisierung",
      "eyebrow": "Funktion",
      "description": "E-Mail- und SMS-Kampagnen, Segmentierung und Automatisierung in Ihrem CRM integriert.",
      "intro": "Erstellen Sie Mailinglisten basierend auf demografischen Merkmalen, Präferenzen und Interaktionen. Erstellen und führen Sie personalisierte E-Mail-Kampagnen in vier einfachen Schritten aus.",
      "sections": [
        {
          "heading": "Personalisiert im großen Maßstab",
          "body": "CRM-E-Mail-Marketing-Software leistet mehr als nur Massen-E-Mails zu versenden – erstellen Sie personalisierte Sequenzen, verwalten Sie zielgerichtete Listen und reagieren Sie automatisch."
        },
        {
          "heading": "Mobilfreundliche Vorlagen",
          "body": "Leicht anpassbare E-Mail-Vorlagen, die auf allen Geräten, einschließlich Mobiltelefonen, Tablets und mehr, responsive sind."
        },
        {
          "heading": "SMS + E-Mail zusammen",
          "body": "Kombinieren Sie E-Mail- und SMS-Sequenzen. Engagieren Sie Ihre Kunden wie nie zuvor und behalten Sie alles an einem Ort."
        }
      ]
    },
    "calendar": {
      "title": "Gruppenkalender",
      "eyebrow": "Funktion",
      "description": "Geteilter Teamkalender mit E-Mail- und SMS-Erinnerungen, vollständig integriert mit Kontakten, Deals und Aufgaben.",
      "intro": "Der FreeCRM Gruppenkalender ist eine großartige Möglichkeit, Ihren Zeitplan, die täglichen, wöchentlichen und monatlichen Aktivitäten Ihres Teams, Kundentermine und Anrufe zu verwalten und anzuzeigen.",
      "sections": [
        {
          "heading": "Verpassen Sie nie ein Event",
          "body": "Senden Sie E-Mail- und SMS-Benachrichtigungen, damit niemand mehr eine Ausrede hat, ein Event zu verpassen."
        },
        {
          "heading": "Mit allem verbunden",
          "body": "Verfolgen Sie anstehende Ereignisse, stellen Sie Erinnerungen ein, erstellen Sie Aufgaben, geben Sie Notizen ein, fügen Sie Dateien an und verknüpfen Sie Kalendereinträge mit einem oder mehreren Kontakten. Weisen Sie Aufgaben einem oder mehreren Kollegen zu."
        },
        {
          "heading": "Filtern nach Team oder Kontakt",
          "body": "Zeigen Sie Ereignisse für die gesamte Datenbank, einen einzelnen Kontakt, sich selbst, einen Kollegen oder mehrere Teammitglieder an. Sie sind nie mehr als einen Klick von der Historie oder den Kontaktinformationen entfernt."
        }
      ]
    },
    "documents": {
      "title": "Dokumentenmanagement",
      "eyebrow": "Funktion",
      "description": "Unbegrenzter Dokumentenspeicher, mobiler Zugriff und dateianhänge pro Datensatz.",
      "intro": "Teilen Sie wichtige Dokumente mit Ihrem Team und bieten Sie sofortigen Zugriff auf alle Ihre elektronischen Dateien. Laden Sie eine einzelne Datei oder ein ganzes Verzeichnis mit einem Klick hoch.",
      "sections": [
        {
          "heading": "Unbegrenzter Speicherplatz",
          "body": "Unser kostenloser Service beinhaltet unbegrenzten Speicherplatz für alle wichtigen Dokumente Ihres Teams. Jedes Mitglied kann seinen eigenen Dokumentenspeicher haben und Dateien mit jedem Datensatz verknüpfen."
        },
        {
          "heading": "Mobile-First",
          "body": "Greifen Sie auf Dokumente über unsere iOS- und Android-Apps zu – öffnen Sie das mobile CRM, rufen Sie ein Dokument auf und senden Sie SMS und E-Mails an Interessenten direkt vor Ort."
        },
        {
          "heading": "Ressourcen zentralisieren",
          "body": "Ein sicherer Ort, um Ihre elektronischen Dokumentenressourcen zu zentralisieren. Ihr Team kann von überall auf der Welt auf Verträge, Verkaufs- und Marketingmaterialien, standardisierte Formulare und mehr zugreifen."
        }
      ]
    },
    "email": {
      "title": "E-Mail-Automatisierung",
      "eyebrow": "Funktion",
      "description": "Personalisierte E-Mail-Sequenzen, segmentierte Listen und CRM-gesteuertes Targeting.",
      "intro": "Erstellen Sie Mailinglisten basierend auf demografischen Merkmalen, Präferenzen und Interaktionen für zielgerichtete Nachrichten. Sparen Sie Zeit und steigern Sie die Produktivität um 74% mit den richtigen E-Mail-Tools.",
      "sections": [
        {
          "heading": "Vier einfache Schritte",
          "body": "Erstellen und führen Sie personalisierte E-Mail-Kampagnen in vier einfachen Schritten mit der CRM-E-Mail-Marketing-Software aus."
        },
        {
          "heading": "Mehr als Masse",
          "body": "CRM-E-Mail-Marketing hilft Teams bei viel mehr als nur der Nachverfolgung von Verkaufsleads, dem Versenden von Massen-E-Mails oder der Erstellung personalisierter Sequenzen."
        },
        {
          "heading": "Responsive Vorlagen",
          "body": "Leicht anpassbare Vorlagen, die auf allen Geräten – Telefonen, Tablets und Desktops – responsive sind."
        }
      ]
    },
    "forms": {
      "title": "Formulare & Umfragen",
      "eyebrow": "Funktion",
      "description": "Mehrseitige Wizard-Formulare, Anrufskripte und Umfragen, die direkt ins CRM fließen.",
      "intro": "Formulare sind Frage-Antwort-Umfragen – und können auch Anrufskripte sein, die Ihr Vertriebs- oder Supportpersonal mit Interessenten am Telefon ausfüllt.",
      "sections": [
        {
          "heading": "Wizard-Formulare",
          "body": "Das Erstellen von Formularen und Umfragen ist mit unserem Formular-Builder einfach und ermöglicht die Erstellung mehrseitiger Wizard-Formulare, die leicht zu befolgen und auszufüllen sind. Nach Fertigstellung erhalten Sie einen öffentlichen Link zur Verteilung."
        },
        {
          "heading": "Kundenfeedback & interne Skripte",
          "body": "Verwenden Sie Formulare für Kundenfeedback, Mitarbeiterfragebögen und Anrufskripte. Erstellen Sie angepasste Umfragen für Vertrieb, Marketing und Kundenzufriedenheit."
        },
        {
          "heading": "Berichterstattung & Export",
          "body": "Webformular- und Umfrageergebnisse fließen in ein Berichtssystem ein und werden als Tabellen dargestellt. Exportieren Sie sie zur Analyse oder für den Marketing-Import nach Excel oder CSV."
        }
      ]
    }
  },
  "industryPages": {
    "callcenter": {
      "title": "FreeCRM für Call Center",
      "eyebrow": "Branche",
      "description": "Callcenter-CRM mit integriertem Dialer, Aufzeichnung, Skripting und SMS in 90 Ländern.",
      "intro": "Automatisieren Sie Inbound- und Outbound-Telefonie in 90 Ländern weltweit. Holen Sie sich eine virtuelle Telefonnummer und stellen Sie Callcenter-Funktionen sofort bereit.",
      "sections": [
        {
          "heading": "Alle Ihre Anrufe, an einem Ort",
          "body": "Click-to-Call-Browservanrufe zu jeder Telefonnummer. Holen Sie sich eine virtuelle Nummer oder verwenden Sie Ihre eigene Mobilnummer – FreeCRM bietet alles."
        },
        {
          "heading": "Aufzeichnung & Planung",
          "body": "Führen Sie Anrufaufzeichnungen durch, planen Sie Anrufe und Gruppenanrufe und senden Sie SMS von jedem Gerät aus. Erweiterte Funktionen für die Callcenter-Automatisierung."
        },
        {
          "heading": "Skripting & Automatisierung",
          "body": "Leistungsstarke Anrufskripte und Automatisierung führen zu zuverlässigen Verkaufsresultaten. Erstellen Sie Skripte, die Teammitgliedern zugewiesen und geplant werden; verfolgen Sie jeden Anruf und seine Ergebnisse in unserem funktionsreichen System."
        },
        {
          "heading": "Kampagnen & Nachfassaktionen",
          "body": "Erstellen Sie Anruf- und SMS-Kampagnen, automatisieren Sie diese und organisieren Sie Nachfassaktionen, damit Ihr Team keinen Kontaktpunkt verpasst."
        }
      ]
    },
    "insurance": {
      "title": "FreeCRM für Versicherungen",
      "eyebrow": "Branche",
      "description": "Versicherungs-CRM-Cloud für Agenten, Vermittler und Dienstleister zur Verfolgung von Kunden, Policen und Ansprüchen.",
      "intro": "Das CRM für die Versicherungsbranche hilft Agenten, Vermittlern und Dienstleistern, an Verbraucher und Unternehmen zu verkaufen und alle Interaktionen in der Cloud zu verfolgen.",
      "sections": [
        {
          "heading": "Für Agenten und Underwriter entwickelt",
          "body": "Egal, ob Sie Agent, Underwriter, Dienstleister oder ein anderer Versicherungsexperte sind, wir können Ihnen bei Ihren CRM-Anforderungen helfen."
        },
        {
          "heading": "Policen, Ansprüche & Kunden",
          "body": "Automatisieren Sie die Verfolgung wichtiger Kunden, Policen, Ansprüche und mehr mit vorgefertigten Versicherungsvorlagen, die für B2C und B2B funktionieren."
        },
        {
          "heading": "Für Retention entwickelt",
          "body": "CRM ist in der Versicherungsbranche aufgrund komplexer Produkte, der Notwendigkeit kontinuierlicher Kommunikation und der Bedeutung der Kundenbindung entscheidend."
        }
      ]
    },
    "realestate": {
      "title": "FreeCRM für Immobilien",
      "eyebrow": "Branche",
      "description": "Lead- und Immobilienverwaltung für private und gewerbliche Immobilienprofis.",
      "intro": "FreeCRM wird in der gesamten Immobilienbranche von jeder Art von Fachleuten eingesetzt – ob privat oder gewerblich, beim Kauf, Verkauf, bei der Maklertätigkeit oder der Verwaltung.",
      "sections": [
        {
          "heading": "Lead- und Immobilienverwaltung",
          "body": "Optimieren Sie Lead-Management und Immobilienverwaltung im Wohn- und Gewerbebereich. Makler lieben unser CRM – ebenso wie Broker und Immobilienverwalter."
        },
        {
          "heading": "Immobilien als Deals auflisten",
          "body": "Verwenden Sie den Bereich „Deals“, um Immobilien aufzulisten – typischerweise nach Adresse (z.B. „Hauptstraße 100“). Fügen Sie einer einzelnen Immobilie mehrere Interessenten hinzu und verwenden Sie das Vertriebsboard oder die Pipeline, um Funnels zu verfolgen."
        },
        {
          "heading": "HOAs und komplexe Vermögenswerte",
          "body": "Immobilienverwalter in Wohnanlagen, Gewerbeimmobilien, Mehrfamilienhäusern, Hochhaus-Eigentumswohnungen und Hausverwaltungen nutzen FreeCRM, um jeden Aspekt des Betriebs zu verwalten."
        }
      ]
    },
    "dental": {
      "title": "FreeCRM für Zahnarztpraxen",
      "eyebrow": "Branche",
      "description": "HIPAA-konformes CRM für Zahnärzte, Oralchirurgen und die spezialisierte Zahnmedizin.",
      "intro": "Wir unterstützen die Zahnmedizinalbranche mit modernstem CRM für Zahnärzte, Oralchirurgen und alle in der spezialisierten medizinischen Gemeinschaft – und bieten BAA-Zertifizierung für HIPAA-Konformität.",
      "sections": [
        {
          "heading": "Vertraut von Tausenden von Praxen",
          "body": "Mit Tausenden von Zahnarztkunden erfüllt FreeCRM die Compliance-Anforderungen der Zahnmedizin, Oralchirurgie, Zahnimplantate und angrenzender Branchen, die Patientendaten verarbeiten."
        },
        {
          "heading": "Datensicherheit",
          "body": "Datensicherheit ist das A und O von FreeCRM. Server werden auf AWS gehostet – HIPAA-konform – und wir stellen BAA-Zertifikate für Praxen bereit, die diese benötigen."
        },
        {
          "heading": "Integrieren Sie Ihren Stack",
          "body": "Beginnen Sie schnell und integrieren Sie sich in die wichtigsten Praxismanagement- und Bildgebungssysteme, die in der Zahnmedizin verwendet werden."
        }
      ]
    },
    "hipaa": {
      "title": "HIPAA-konformes CRM",
      "eyebrow": "Compliance",
      "description": "FreeCRM ist seit über einem Jahrzehnt HIPAA-konform – BAA-Zertifikate für Enterprise verfügbar.",
      "intro": "Die Verwaltung von Patienteninformationen ist eine Herausforderung. FreeCRM hat HIPAACRM.com 2014 ins Leben gerufen – das weltweit erste HIPAA-konforme CRM – und bleibt führend in Sachen Sicherheit und Verantwortlichkeit.",
      "sections": [
        {
          "heading": "Benötigen Sie ein BAA?",
          "body": "Wenn Sie ein Business Associate Addendum (BAA) Zertifikat benötigen, um die HIPAA-Konformität zu gewährleisten, können wir Ihnen helfen. Unsere Enterprise-Edition ist erforderlich und wird jährlich pro Platz im Voraus abgerechnet ($300/Benutzer/Jahr)."
        },
        {
          "heading": "Mehr als nur Arztpraxen",
          "body": "Nicht nur Arztpraxen – klinische Studien, Ernährungsberater, Therapeuten und jedes Unternehmen, das Gesundheitsinformationen verarbeitet, nutzen unsere HIPAA-Unterstützung."
        },
        {
          "heading": "Modernste Sicherheit",
          "body": "12 Jahre HIPAA-Erfahrung, gehostet auf AWS, mit der Sicherheit und Verantwortlichkeit, die Sie für geschützte Gesundheitsinformationen benötigen."
        }
      ]
    },
    "insidesales": {
      "title": "FreeCRM für internen & unabhängigen Vertrieb",
      "eyebrow": "Branche",
      "description": "Steigern Sie die Produktivität um über 30% mit einfacher CRM-Automatisierung für interne und unabhängige Vertriebsmitarbeiter.",
      "intro": "FreeCRM hilft unabhängigen Vertriebsmitarbeitern und internen Vertriebsteams, die Produktivität mit einfachen CRM-Automatisierungs-Tools und Dashboards zu steigern.",
      "sections": [
        {
          "heading": "30%+ mehr Produktivität",
          "body": "Unabhängige Vertriebsmitarbeiter können ihre Verkäufe um über 30% steigern, indem sie einfach Kontakte und Unternehmen verfolgen – und unsere Automatisierungstools verstärken den Effekt."
        },
        {
          "heading": "Jede Interaktion verfolgen",
          "body": "Protokollieren Sie jeden Anruf, jede E-Mail und jedes Meeting. Halten Sie klar fest, was gesagt wurde und was als Nächstes passieren muss, priorisieren Sie Aufgaben und reagieren Sie zeitnah."
        },
        {
          "heading": "Selbstständigenfreundlich",
          "body": "Entwickelt für die Autonomie unabhängiger Vertriebsmitarbeiter, die mehrere Unternehmen vertreten. Verwalten Sie Ihren eigenen Zeitplan und Kundenbeziehungen von überall aus."
        }
      ]
    },
    "contractor": {
      "title": "FreeCRM für Bauunternehmer & Baumeister",
      "eyebrow": "Branche",
      "description": "Verwalten Sie Deals, Subunternehmer, Zeitpläne und Echtzeit-Benachrichtigungen für Generalunternehmer und gewerbliche Baumeister.",
      "intro": "Bauunternehmer, Baumeister, Generalunternehmer und Anbieter von gewerblichen Bauleistungen nutzen FreeCRM problemlos zur Verwaltung von Deals und mehreren Dritten wie Subunternehmern.",
      "sections": [
        {
          "heading": "Lead-Management",
          "body": "Verfolgen Sie Leads, überwachen Sie den Fortschritt und priorisieren Sie Anstrengungen. Erhalten Sie Einblicke in das Lead-Verhalten, um zu entscheiden, welche Sie verfolgen sollten."
        },
        {
          "heading": "Kostenvoranschläge & Angebote",
          "body": "Automatisieren Sie den Prozess der Kostenschätzung und Angebotsstellung mit einer zentralisierten Datenbank früherer Angebote, Kostenvoranschläge und Preisdaten – das spart Zeit und verbessert die Genauigkeit."
        },
        {
          "heading": "Planung & Benachrichtigungen",
          "body": "Weisen Sie Teams und Einzelpersonen schnell mit Echtzeit-Benachrichtigungen per E-Mail oder SMS zu. Halten Sie Subunternehmer und Teams koordiniert."
        }
      ]
    },
    "professional": {
      "title": "FreeCRM für professionelle Dienstleistungen",
      "eyebrow": "Branche",
      "description": "Kundenmanagement, Compliance und Servicebereitstellung für professionelle Dienstleistungsunternehmen.",
      "intro": "Professionelle Dienstleistungsunternehmen nutzen FreeCRM, um Kundendaten zu verwalten, Interaktionen zu verfolgen und besseren Service von überall und auf jedem Gerät zu bieten.",
      "sections": [
        {
          "heading": "Verbesserte Kundenzufriedenheit",
          "body": "Eine vollständige Übersicht über die Kundenbeziehung – Kontaktdaten, vergangene Transaktionen, Kommunikationspräferenzen – führt zu höherer Zufriedenheit und Loyalität."
        },
        {
          "heading": "Einfachere Compliance",
          "body": "Erfüllen Sie DSGVO und ähnliche Anforderungen mit einem zentralen Speicherort, um Compliance-Dokumente zu speichern und zu teilen, und Transparenz über die Kundendatenquellen."
        },
        {
          "heading": "Firma wachsen lassen",
          "body": "CRM muss heute von überall, auf jedem Gerät und in jeder Sprache zugänglich sein – mit integrierter Sozial- und Best-Practice-Intelligenz, um Ihnen zu helfen, schneller voranzukommen."
        }
      ]
    }
  },
  "integrationPages": {
    "google": {
      "title": "FreeCRM + Google Workspace",
      "eyebrow": "Integration",
      "description": "Synchronisieren Sie Gmail, Google Calendar und Google Contacts mit FreeCRM mit einem Klick.",
      "intro": "Gmail und Google Workspace sind tiefgreifend in FreeCRM integriert. Verbinden Sie Ihr Google-Konto und synchronisieren Sie E-Mails, Kontakte und Kalender.",
      "sections": [
        {
          "heading": "Ein-Klick-Einrichtung",
          "body": "Es ist einfach, Ihr Google-Konto hinzuzufügen – genau wie jede andere Google-integrierte App ist es ein Login mit einem Klick. Sie können Ihr Google-Konto auch verwenden, um sich bei FreeCRM anzumelden."
        },
        {
          "heading": "Synchronisieren, was Sie möchten",
          "body": "Sobald Sie Google zu FreeCRM hinzugefügt haben, wählen Sie, ob Sie das gesamte Konto synchronisieren oder nur die integrierte E-Mail-Funktionalität nutzen möchten. Kalender und Google Contacts werden beim Synchronisieren mit übernommen."
        },
        {
          "heading": "Workspace wird zum CRM",
          "body": "Hoch integrierte CRM-Systeme können Google Workspace in ein leistungsstarkes CRM verwandeln, das mit Unternehmens-Google-Hosting oder jedem Gmail-Konto funktioniert."
        }
      ]
    },
    "quickbooks": {
      "title": "FreeCRM + QuickBooks",
      "eyebrow": "Integration",
      "description": "Die am besten bewertete QuickBooks CRM-Integration — Online und Desktop, Zwei-Wege-Synchronisierung.",
      "intro": "Die beste QuickBooks-Integration – von QuickBooks ProAdvisors als #1 bewertet. CRM für QuickBooks Online und Desktop vereinfacht Abläufe und hilft Ihnen, den Umsatz zu steigern.",
      "sections": [
        {
          "heading": "Nahtlos integriert",
          "body": "Wenn Sie eine CRM-Anwendung suchen, die nahtlos mit QuickBooks Online integriert ist, ist FreeCRM die perfekte Lösung."
        },
        {
          "heading": "Kundendaten zentralisieren",
          "body": "Ein CRM, das mit QuickBooks integriert ist, nutzt Buchhaltungssoftware-Integrationen, um Ihre Kundendaten über Vertrieb und Finanzen hinweg zu speichern und zu zentralisieren."
        },
        {
          "heading": "Online + Desktop",
          "body": "Sowohl QuickBooks Online als auch QuickBooks Desktop werden unterstützt."
        }
      ]
    },
    "zapier": {
      "title": "FreeCRM + Zapier",
      "eyebrow": "Integration",
      "description": "Verbinden Sie FreeCRM mit über 6.000 Apps auf Zapier — der einfachste Weg zur Automatisierung.",
      "intro": "Verbinden Sie den FreeCRM-Connector sofort mit den Apps, die Sie täglich nutzen. FreeCRM integriert sich mit über 6.000 weiteren Apps auf Zapier — dem einfachsten Weg zur Automatisierung.",
      "sections": [
        {
          "heading": "Über 6.000 Apps",
          "body": "Von Slack über Stripe bis zu Google Sheets können Sie Daten von FreeCRM in den Rest Ihres Stacks übertragen und abrufen, ohne Code schreiben zu müssen."
        },
        {
          "heading": "No-Code-Automatisierung",
          "body": "Erstellen Sie Zaps, um Anrufe zu protokollieren, Kontakte zu erstellen, Deals zu synchronisieren und Kampagnen auszulösen, wann immer etwas in Ihren anderen Tools geschieht."
        }
      ]
    },
    "docusign": {
      "title": "FreeCRM + DocuSign",
      "eyebrow": "Integration",
      "description": "Senden, unterschreiben und verfolgen Sie Vereinbarungen direkt aus Ihrem CRM mit DocuSign-Integration.",
      "intro": "DocuSign ist die weltweit führende Plattform zum Unterschreiben von Dokumenten. FreeCRM ermöglicht es Ihnen, Prozesse zu optimieren, indem Dokumente mit CRM-Daten befüllt und das CRM aus DocuSign-Feldern aktualisiert werden.",
      "sections": [
        {
          "heading": "Echtzeit-Tracking",
          "body": "Fordern Sie Unterschriften an und verfolgen Sie den Status von Vereinbarungen in Echtzeit. Sparen Sie Zeit mit benutzerdefinierten Workflows, die Vereinbarungen auf Knopfdruck auslösen – und reduzieren Sie Fehler."
        },
        {
          "heading": "Zwei-Wege-Datenfluss",
          "body": "Automatisieren Sie ganze Workflows, generieren und senden Sie Verträge und archivieren Sie abgeschlossene Dokumente. Aktualisieren Sie Systeme mit Dokumentendaten oder füllen Sie Dokumente aus dem CRM – es funktioniert in beide Richtungen."
        }
      ]
    },
    "whatsapp": {
      "title": "FreeCRM + WhatsApp",
      "eyebrow": "Integration",
      "description": "Nutzen Sie die WhatsApp Business API für Anrufe und Textnachrichten direkt in FreeCRM.",
      "intro": "WhatsApp und FreeCRM bilden eine leistungsstarke Kombination – nutzen Sie die WhatsApp Business API für Anrufe und Textnachrichten und automatisieren Sie die Lead-Erfassung und Kommunikation.",
      "sections": [
        {
          "heading": "Optimierte Kommunikation",
          "body": "Verwalten Sie WhatsApp-Kundeninteraktionen an einem zentralen Ort für schnellere Reaktionszeiten und höhere Zufriedenheit."
        },
        {
          "heading": "Kunden-Datenintegration",
          "body": "Importieren Sie WhatsApp-Kundendaten in FreeCRM und automatisieren Sie wiederkehrende Aufgaben wie Nachrichtenweiterleitung, Priorisierung von Antworten und Dateneingabe."
        }
      ]
    },
    "microsoft365": {
      "title": "FreeCRM + Microsoft 365",
      "eyebrow": "Integration",
      "description": "Synchronisieren Sie Outlook, Kalender und Kontakte mit FreeCRM über Microsoft 365.",
      "intro": "Microsoft 365 ist in FreeCRM integriert, sodass Sie Outlook-E-Mails, Kalender und Kontakte an einem Ort synchronisieren können.",
      "sections": [
        {
          "heading": "Microsoft-Anmeldung mit einem Klick",
          "body": "Verbinden Sie Ihr Microsoft 365-Konto und verwenden Sie es, um sich bei FreeCRM anzumelden – genau wie bei jeder anderen Microsoft-integrierten App."
        },
        {
          "heading": "E-Mail, Kalender und Kontakte",
          "body": "Wählen Sie, was synchronisiert werden soll – E-Mail-Unterhaltungen, Kalenderereignisse und Outlook-Kontakte werden zwischen FreeCRM und Microsoft 365 stets aktuell gehalten."
        },
        {
          "heading": "Teambereit",
          "body": "Funktioniert mit Outlook Personal, Microsoft 365 Business und Enterprise-Mandanten, damit Ihr gesamtes Team synchronisiert bleibt."
        }
      ]
    },
    "video-conferencing": {
      "title": "FreeCRM + Videokonferenzen",
      "eyebrow": "Integration",
      "description": "Generieren Sie automatisch Zoom-, Google Meet- und Zoho Meeting-Links für jedes geplante Meeting.",
      "intro": "Die FreeCRM-Terminplanung erstellt automatisch Videokonferenz-Links für jedes Meeting. Verbinden Sie Zoom, Google Meet und Zoho Meeting, damit Interessenten und Kunden mit einem Klick beitreten können.",
      "sections": [
        {
          "heading": "Automatische Meeting-Links",
          "body": "Wenn jemand über Ihren FreeCRM-Buchungslink ein Meeting bucht, wird ein Zoom-, Google Meet- oder Zoho Meeting-Link generiert und automatisch in die Kalendereinladung eingefügt."
        },
        {
          "heading": "Mehrere Anbieter",
          "body": "Nutzen Sie den Anbieter, für den Ihr Team bereits zahlt – Zoom, Google Meet oder Zoho Meeting – oder lassen Sie die Teilnehmer wählen."
        },
        {
          "heading": "Einheitlicher Kalender",
          "body": "Meeting-Details, Links und Aufzeichnungen bleiben am Kontakt-, Deal- oder Case-Datensatz angehängt, damit alles an einem Ort ist."
        }
      ]
    },
    "aws": {
      "title": "FreeCRM auf AWS",
      "eyebrow": "Infrastruktur",
      "description": "Six-Nines-Verfügbarkeit, 24/7/365 Ingenieure und Datensicherheit auf Bundesniveau auf Amazon AWS.",
      "intro": "FreeCRM läuft auf Amazon AWS mit einer angestrebten Verfügbarkeit von sechs Neunen (99,9999%). Ingenieure sind rund um die Uhr, 24/7/365 im Einsatz.",
      "sections": [
        {
          "heading": "Einrichtungen auf Bundesniveau",
          "body": "Unsere physischen Einrichtungen erfüllen oder übertreffen alle nationalen und internationalen Anforderungen an Datensicherheit, Redundanz, Geschäftsfortführung und Kontinuität."
        },
        {
          "heading": "Höchste Cloud-Qualität",
          "body": "Vertrauen Sie uns, die höchste verfügbare Cloud-Dienstleistungsqualität zu liefern – verschlüsselt, überwacht und ständig verfügbar."
        }
      ]
    }
  },
  "footerPages": {
    "features": {
      "title": "Alles, was Sie in einem CRM benötigen",
      "eyebrow": "Funktionen",
      "description": "Integrierte Telefonie, SMS, Deals, Kontakte, Aufgaben, Fälle, Kampagnen, Kalender, Dokumente, Berichte, API und Integrationen – dauerhaft kostenlos.",
      "intro": "FreeCRM bietet Ihnen Kontakte, Unternehmen, Deals, Aufgaben, Fälle, Anrufe, Kalender, Dokumente, Berichte, Kampagnen, Formulare, E-Mail, API und Integrationen – alles an einem Ort, dauerhaft kostenlos."
    },
    "pricing": {
      "title": "Preise",
      "description": "Free CRM dauerhaft kostenlos. Pro für $10/Benutzer/Monat. Enterprise für $25/Benutzer/Monat. US-Nummern $1.15/Monat, $0.01/min, $0.01/SMS."
    },
    "integrations": {
      "title": "Integrationen & verbundene Apps",
      "eyebrow": "Integrationen",
      "description": "Verbinden Sie FreeCRM mit Google, Microsoft 365, QuickBooks, Zapier, DocuSign, WhatsApp, Zoom, Google Meet, Zoho Meeting und über 6.000 Apps.",
      "intro": "FreeCRM verbindet sich mit den Tools, die Sie bereits nutzen – Google Workspace, Microsoft 365, QuickBooks, Zapier, DocuSign, WhatsApp, Zoom, Google Meet, Zoho Meeting und Tausenden weiteren – um Ihre Daten synchron zu halten und Ihre Workflows zu automatisieren."
    },
    "changelog": {
      "title": "Was ist neu in FreeCRM",
      "eyebrow": "Changelog",
      "description": "Aktuelle Verbesserungen, neue Funktionen und Fehlerbehebungen für FreeCRM.",
      "intro": "Wir liefern kontinuierlich Verbesserungen. Hier sind die Highlights der letzten Releases.",
      "sections": [
        {
          "heading": "Mai 2026 — Power Dialer 2.0",
          "body": "Schnellere Anwahl mit lokaler Präsenz, intelligenterer Voicemail-Drop und Anrufstatus-Verknüpfungen, die die Nachbearbeitungszeit halbieren."
        },
        {
          "heading": "April 2026 — Neue iOS & Android Apps",
          "body": "Brandneue mobile Apps mit Offline-Unterstützung, Push-Benachrichtigungen für eingehende Anrufe und SMS sowie vollständiger Pipeline-Zugriff von Ihrem Telefon aus."
        },
        {
          "heading": "März 2026 — QuickBooks Zwei-Wege-Synchronisierung",
          "body": "Kunden, Rechnungen und Zahlungen werden jetzt bidirektional zwischen FreeCRM und QuickBooks Online und Desktop synchronisiert."
        },
        {
          "heading": "Februar 2026 — Anruf-Coaching",
          "body": "Live-Mithören, Flüstern und Eingreifen für Manager, plus KI-gestütztes Anrufbewertungssystem in der Enterprise-Version."
        }
      ]
    },
    "about": {
      "title": "Über FreeCRM",
      "eyebrow": "Unternehmen",
      "description": "Seit 2003 bietet FreeCRM das weltweit erste vollständig kostenlose CRM an und leistet Pionierarbeit für das Freemium-Modell für Vertriebs-, Service- und Marketingteams.",
      "intro": "Warum ist FreeCRM kostenlos? Weil wir an Ihr Unternehmen glauben. Wir bieten seit 2003 das weltweit erste vollständig kostenlose CRM an – und haben Hunderttausenden von Unternehmen geholfen, zu wachsen.",
      "sections": [
        {
          "heading": "Warum kostenlos?",
          "body": "Wir geben Ihnen ein kostenloses CRM als Investition in Sie und Ihr Unternehmen. Wir wissen, dass wir Ihnen zum Erfolg verhelfen werden und dass Sie uns in Zukunft vielleicht bezahlen werden. Wenn Ihre Verkäufe wachsen, werden Sie mehr Funktionen wünschen – und Pro und Enterprise stehen bereit, wenn Sie so weit sind."
        },
        {
          "heading": "Wir waren Pioniere des Freemium-Modells",
          "body": "FreeCRM war Pionier des Freemium-Modells: Leistungsstarke Software kostenlos, mit der Option zum Upgrade für SMS, Telefonie, QuickBooks, erweiterten API-Zugang, Zapier und mehr."
        },
        {
          "heading": "Basierend auf AWS",
          "body": "Wir nehmen Datensicherheit ernst. FreeCRM läuft auf Amazon AWS mit einer angestrebten Verfügbarkeit von sechs Neunen (99,9999%). Ingenieure sind rund um die Uhr, 24/7/365 im Einsatz, und unsere Einrichtungen erfüllen oder übertreffen nationale und internationale Anforderungen an Datensicherheit, Redundanz und Kontinuität."
        },
        {
          "heading": "Umfassend im Design",
          "body": "Ein robustes CRM ist eine umfassende Arbeitsanwendung, die sowohl Front- als auch Back-Office-Operationen abwickelt. FreeCRM ist so leistungsstark – und kostenlos – und deckt Vertrieb, Service, Marketing, Telefonie und Betrieb an einem Ort ab."
        }
      ]
    },
    "customers": {
      "title": "Kunden lieben FreeCRM",
      "eyebrow": "Kunden",
      "description": "Erfahren Sie, wie Outbound-Vertriebsteams, Call Center und SMBs FreeCRM nutzen, um 40% mehr Anrufe zu tätigen und Deals schneller abzuschließen.",
      "intro": "Hunderttausende von Teams – von Startups mit zwei Personen bis zu Call Centern mit 50 Plätzen – wickeln Vertrieb und Service auf FreeCRM ab.",
      "sections": [
        {
          "heading": "Interner Vertrieb – 40% mehr Anrufe",
          "body": "„Unsere SDRs haben ihre Anrufe von 80 pro Tag auf über 110 gesteigert, nachdem wir zu FreeCRM gewechselt waren. Der Power Dialer und die Click-to-Call-Funktion in der Kontaktansicht haben alles verändert.“ — VP Sales, B2B SaaS"
        },
        {
          "heading": "Call Center – hat einen $18.000/Jahr Stack ersetzt",
          "body": "„Wir haben unseren Dialer, unser CRM und unsere SMS-Tools durch FreeCRM ersetzt und dabei 18.000 Dollar pro Jahr gespart – ohne eine einzige Funktion zu verlieren, die unseren Mitarbeitern wichtig war.“ — Operations Director, Versicherungen"
        },
        {
          "heading": "KMU – 50 Plätze migriert",
          "body": "„Wir haben FreeCRM in zwei Wochen für 50 Agenten eingeführt. Die Bereitstellung lokaler Nummern und die Anrufaufzeichnung waren am ersten Tag live.“ — Head of Revenue, Home Services"
        },
        {
          "heading": " gemeinnützige Organisation – Spenderverwaltung",
          "body": "„FreeCRM ermöglicht es uns, Spender wie Kontakte und Zusagen wie Deals zu behandeln. Der Preis stimmt, und die Anruffunktionen sind ein Game Changer.“ — Geschäftsführer, NPO"
        }
      ]
    },
    "careers": {
      "title": "Karriere bei FreeCRM",
      "eyebrow": "Karriere",
      "description": "Werden Sie Teil eines remote-first Teams, das das weltweit beliebteste kostenlose CRM mit integrierter Telefonie und SMS entwickelt.",
      "intro": "Wir sind ein remote-first Team, das das weltweit beliebteste kostenlose CRM entwickelt. Wenn Sie einfache Software, schnelle Iteration und Kunden lieben, die das, was Sie bauen, tatsächlich nutzen, würden wir uns freuen, mit Ihnen zu sprechen.",
      "sections": [
        {
          "heading": "Wie wir arbeiten",
          "body": "Kleine Teams, asynchron-first, schriftlich-first. Wir liefern jede Woche. Wir stellen Senior-Mitarbeiter ein, vertrauen darauf, dass sie ihre Arbeit eigenverantwortlich erledigen, und zahlen wettbewerbsfähig in Bar und Anteilen."
        },
        {
          "heading": "Offene Stellen",
          "body": ""
        },
        {
          "heading": "So bewerben Sie sich",
          "body": "Senden Sie eine E-Mail an careers@freecrm.com mit der Rolle, an der Sie interessiert sind, einer kurzen Notiz, warum, und Links zu Ihrer Arbeit. Wir antworten auf jede Bewerbung."
        }
      ],
      "roles": [
        "Senior Full-stack Engineer (React / Node)",
        "Telephony Engineer (WebRTC, SIP)",
        "Product Designer",
        "Customer Success — Outbound Sales",
        "Account Executive — SMB"
      ]
    },
    "contact": {
      "title": "FreeCRM kontaktieren",
      "eyebrow": "Kontakt",
      "description": "Sprechen Sie mit dem Vertrieb, erhalten Sie Produktsupport oder erreichen Sie unsere Datenschutz- und Sicherheitsteams.",
      "intro": "Wir sind hier, um Ihnen zu helfen. Erreichen Sie das richtige Team über die unten stehenden Angaben – wir antworten normalerweise innerhalb eines Werktages.",
      "sections": [
        {
          "heading": "Vertrieb",
          "body": "Möchten Sie eine exemplarische Einführung in Pro oder Enterprise oder Hilfe beim Portieren von Nummern und der Migration von HubSpot? Senden Sie eine E-Mail an sales@freecrm.com."
        },
        {
          "heading": "Support",
          "body": "Bestehender Kunde? Eröffnen Sie ein Ticket in der App oder senden Sie eine E-Mail an support@freecrm.com. Pro- und Enterprise-Kunden erhalten vorrangige Antworten."
        },
        {
          "heading": "Datenschutz & Sicherheit",
          "body": "Datenschutzfragen: privacy@freecrm.com. Sicherheitsmeldungen: security@freecrm.com. Wir bestätigen Meldungen innerhalb von 24 Stunden."
        },
        {
          "heading": "Postanschrift",
          "body": "FreeCRM, Inc. — Customer Communications — Delaware, USA"
        }
      ]
    },
    "blog": {
      "title": "Der FreeCRM Blog",
      "eyebrow": "Blog",
      "description": "Playbooks, detaillierte Produktanalysen und Kundengeschichten für Outbound-Vertriebsteams und Call Center.",
      "intro": "Praktische Playbooks für Outbound Sales, Inside Sales und SMB Call Operations – geschrieben vom Team, das FreeCRM entwickelt.",
      "sections": [
        {
          "heading": "Wie man einen Power Dialer in 10 Minuten einrichtet",
          "body": "Eine Schritt-für-Schritt-Anleitung zur Bereitstellung von Nummern, zum Importieren einer Liste und zum Starten Ihrer ersten Power-Dial-Sitzung in FreeCRM."
        },
        {
          "heading": "5 Wege, wie FreeCRM HubSpot in der Telefonie schlägt",
          "body": "Integrierte Sprach- und SMS-Funktionen, keine Minutenaufschläge, dauerhaft kostenlos – die Anruffunktionen in FreeCRM im Vergleich zum Sales Hub von HubSpot."
        },
        {
          "heading": "Von Tabellen zu einem CRM an einem Nachmittag",
          "body": "So importieren Sie Kontakte, richten Ihre Pipeline ein und beginnen, Deals in FreeCRM an einem einzigen Nachmittag zu verfolgen."
        },
        {
          "heading": "Aufbau eines Call Centers mit 50 Mitarbeitern auf FreeCRM",
          "body": "Wie ein Dienstleistungsunternehmen FreeCRM innerhalb von zwei Wochen für 50 Agenten eingeführt hat – einschließlich der Bereitstellung lokaler Nummern und der Anrufaufzeichnung."
        }
      ]
    },
    "help": {
      "title": "Hilfe-Center",
      "eyebrow": "Ressourcen",
      "description": "Anleitungen, Tutorials und Antworten, um FreeCRM optimal zu nutzen.",
      "intro": "Suchen Sie in Anleitungen und Tutorials oder stöbern Sie nach Themen. Pro- und Enterprise-Kunden erhalten auch prioritären E-Mail-Support.",
      "sections": [
        {
          "heading": "Erste Schritte",
          "body": "Erstellen Sie Ihr Konto, laden Sie Ihr Team ein, importieren Sie Kontakte und konfigurieren Sie Ihre Pipeline. Die meisten Teams sind in weniger als einer Stunde einsatzbereit."
        },
        {
          "heading": "Anrufe & SMS",
          "body": "Stellen Sie Nummern bereit, richten Sie Click-to-Call ein, zeichnen Sie Anrufe auf, verwenden Sie den Power Dialer und senden Sie kostenlose SMS von jedem Kontaktdatensatz aus."
        },
        {
          "heading": "Pipelines & Deals",
          "body": "Passen Sie Phasen an, erstellen Sie Berichte und Prognosen und verfolgen Sie jeden Deal vom Angebot bis zur Rechnung."
        },
        {
          "heading": "Integrationen",
          "body": "Verbinden Sie Google, Microsoft 365, QuickBooks, Zapier, DocuSign, Zoom, Google Meet, Zoho Meeting und über 6.000 Apps. Synchronisieren Sie Kontakte, Kalender, E-Mails, Rechnungen und mehr."
        },
        {
          "heading": "Admin & Sicherheit",
          "body": "Verwalten Sie Benutzer, Rollen, SSO, Audit-Logs und Datenexport. Enterprise-Kunden erhalten außerdem SCIM-Bereitstellung und einen dedizierten CSM."
        }
      ]
    },
    "apiDocs": {
      "title": "CRM API",
      "eyebrow": "API-Dokumentation",
      "description": "Eine standardbasierte REST-API zur Erfassung von Leads, Datensynchronisierung und zur Automatisierung des Inbound-Vertriebs und Supports in FreeCRM.",
      "intro": "Holen Sie das Beste aus Ihrem CRM heraus und automatisieren Sie den Inbound-Vertrieb und den Kundenservice. Unsere API Web Services ermöglichen es Ihrer Website, Daten direkt in FreeCRM zu pushen und zu pullen.",
      "whatHeading": "Was Sie tun können",
      "capturesHeading": "Website-Leads erfassen",
      "authHeading": "Authentifizierung",
      "webhooksHeading": "Webhooks",
      "rateLimitsHeading": "Ratenbegrenzungen & SDKs",
      "sections": [
        {
          "heading": "Was Sie tun können",
          "body": "Verbinden Sie Webformulare, leiten Sie eingehende E-Mails weiter, öffnen Sie Supportfälle, erfassen Sie Leads und synchronisieren Sie Daten mit jedem externen System. Wir verwenden eine standardbasierte REST-API, die sich einfach in jede Technologie integrieren lässt."
        },
        {
          "heading": "Website-Leads erfassen",
          "body": "Fügen Sie unsere Code-Vorlage zu jedem Webformular hinzu und beginnen Sie, Kunden-Support- und Vertriebsleads in Echtzeit direkt in FreeCRM zu erfassen. Reduzieren Sie eingehende E-Mail-Geräusche und verlieren Sie nie einen Lead."
        },
        {
          "heading": "Webhooks",
          "body": "Abonnieren Sie Ereignisse – contact.created, deal.updated, call.completed, sms.received – und pushen Sie diese in Echtzeit in Ihre eigenen Systeme."
        },
        {
          "heading": "Ratenbegrenzungen & SDKs",
          "body": "1.000 Anfragen / Minute bei Pro, 5.000 / Minute bei Enterprise. Offizielle Node- und Python-SDKs sind verfügbar; Community-Bibliotheken decken Ruby, PHP und Go ab."
        }
      ]
    },
    "community": {
      "title": "FreeCRM Community",
      "eyebrow": "Community",
      "description": "Vernetzen Sie sich mit Tausenden von FreeCRM-Nutzern, teilen Sie Playbooks und erhalten Sie Antworten vom Team.",
      "intro": "Schließen Sie sich Tausenden von FreeCRM-Nutzern an, teilen Sie Playbooks, Automatisierungen und Best Practices für Outbound-Sales- und Callcenter-Operationen.",
      "sections": [
        {
          "heading": "Foren",
          "body": "Stellen Sie Fragen, teilen Sie Erfolge und lernen Sie von Teams, die FreeCRM in jeder Größe einsetzen – von Solo-Gründern bis zu Call Centern mit 50 Plätzen."
        },
        {
          "heading": "Slack & Discord",
          "body": "Echtzeit-Kanäle für Power User, Administratoren und Entwickler, die auf der FreeCRM API aufbauen. Das Produktteam ist dort auch aktiv."
        },
        {
          "heading": "Sprechstunden",
          "body": "Wöchentliche Live-Sitzungen zu Onboarding, Power Dialing, Integrationen und neuen Funktionen. Kostenlos für alle Kunden."
        }
      ]
    },
    "privacy": {
      "title": "Datenschutzrichtlinie",
      "eyebrow": "Rechtliches",
      "description": "FreeCRM-Datenschutzrichtlinie: Ihre Daten sind immer privat und werden niemals an Dritte weitergegeben.",
      "intro": "Ihre Daten sind immer privat. Wir geben Kundendaten nicht an Dritte weiter.",
      "sections": [
        {
          "heading": "Erhebung und Nutzung von Informationen",
          "body": "Ihre Daten sind zu 100% privat. Wir nutzen die von Ihnen in das System eingegebenen Daten ausschließlich zur Unterstützung Ihres CRM. Die von Ihnen eingegebenen Daten bleiben das alleinige Eigentum der Personen und Organisationen, die sie eingegeben haben. Diese Daten werden niemals an externe Organisationen oder Dritte weitergegeben. Im Falle einer Akquisition, Insolvenz, Eigentümerwechsel oder einer sonstigen Änderung der Unternehmensstruktur stellen wir stets sicher, dass Ihre Daten privat und unversehrt bleiben."
        },
        {
          "heading": "Was wir sammeln",
          "body": "Wir erfassen personenbezogene Daten, die zur Bereitstellung des Dienstes erforderlich sind: Name, E-Mail, Telefon, Rechnungsdaten und die Daten, die Sie in Ihrem CRM speichern möchten. Wir erfassen Protokoll- und Nutzungsdaten, um den Dienst zu betreiben, zu sichern und zu verbessern."
        },
        {
          "heading": "Wie wir Informationen verwenden",
          "body": "Wir verwenden Informationen, um den Dienst bereitzustellen und zu verbessern, mit Ihnen zu kommunizieren, Support zu leisten, die Plattform zu sichern und rechtlichen Verpflichtungen nachzukommen. Wir verkaufen niemals personenbezogene Daten."
        },
        {
          "heading": "Weitergabe",
          "body": "Wir geben Nutzerinformationen nicht weiter und verkaufen sie auch nicht. Wir beauftragen vertrauenswürdige Unterauftragsverarbeiter (wie unsere Cloud- und Telefonieanbieter) ausschließlich zum Betrieb des Dienstes, unter Verträgen, die Vertraulichkeit und Datenschutz erfordern."
        },
        {
          "heading": "Wahlmöglichkeiten & Korrekturen",
          "body": "Sie können Ihre Daten jederzeit in der App oder durch Kontaktaufnahme mit privacy@freecrm.com abrufen, korrigieren, exportieren oder löschen."
        },
        {
          "heading": "Sicherheit",
          "body": "FreeCRM wird auf Amazon AWS betrieben und verfügt über branchenübliche physische, Netzwerk- und Anwendungssicherheitskontrollen, Verschlüsselung während der Übertragung und im Ruhezustand sowie eine 24/7/365-Überwachung."
        },
        {
          "heading": "Kontakt",
          "body": "Fragen oder Bedenken? Senden Sie eine E-Mail an privacy@freecrm.com. Wir werden innerhalb eines angemessenen Zeitrahmens antworten."
        }
      ]
    },
    "terms": {
      "title": "Allgemeine Geschäftsbedingungen",
      "eyebrow": "Rechtliches",
      "description": "Die Abonnementvereinbarung, die Ihre Nutzung der FreeCRM-Software und -Dienste regelt.",
      "intro": "Durch die Nutzung der FreeCRM-Software erklären Sie sich im Namen der das Software lizenzierenden Einheit mit dieser Abonnementvereinbarung einverstanden.",
      "sections": [
        {
          "heading": "1. Annahme",
          "body": "Durch Klicken auf „Ich akzeptiere“ oder die Nutzung der von Ihnen ausgewählten FreeCRM-Software erklären Sie sich im Namen des Unternehmens, das die Software lizenziert (im Folgenden „Unternehmen“), damit einverstanden, dass das Unternehmen Partei dieser Vereinbarung wird und dass Sie befugt sind, das Unternehmen zu binden. Wenn das Unternehmen nicht zustimmt, registrieren oder nutzen Sie die Software nicht."
        },
        {
          "heading": "2. Leistungsbeschreibung",
          "body": "FreeCRM erbringt seine Dienstleistung gemäß diesen Nutzungsbedingungen, die von uns von Zeit zu Zeit aktualisiert werden können. Die aktuelle Version ist stets unter dieser URL veröffentlicht. Bestimmte Funktionen können zusätzlichen veröffentlichten Richtlinien unterliegen, die durch Verweis einbezogen werden."
        },
        {
          "heading": "3. Ihr Konto",
          "body": "Sie sind für die Vertraulichkeit Ihrer Anmeldedaten und für alle Aktivitäten verantwortlich, die unter Ihrem Konto stattfinden. Benachrichtigen Sie uns unverzüglich über jede unbefugte Nutzung."
        },
        {
          "heading": "4. Zulässige Nutzung",
          "body": "Sie stimmen zu, FreeCRM nicht zum Versenden von Spam, zur Belästigung anderer, zur Verletzung von geistigem Eigentum, zur Verbreitung von Malware oder zur Verletzung geltenden Rechts zu nutzen. Wir können Konten sperren, die gegen diese Regeln verstoßen."
        },
        {
          "heading": "5. Gebühren",
          "body": "Der kostenlose Plan wird unentgeltlich angeboten. Pro- und Enterprise-Pläne werden monatlich oder jährlich im Voraus abgerechnet. Die Telefonnutzung (Nummern, Minuten, SMS) wird gemäß den veröffentlichten Tarifen abgerechnet."
        },
        {
          "heading": "6. Datenhoheit",
          "body": "Sie behalten alle Rechte an den Daten, die Sie in FreeCRM eingeben. Wir verarbeiten sie ausschließlich zur Bereitstellung und Verbesserung des Dienstes."
        },
        {
          "heading": "7. Kündigung",
          "body": "Jede Partei kann jederzeit kündigen. Nach der Kündigung können Sie Ihre Daten exportieren; nach einer angemessenen Frist können wir sie löschen."
        },
        {
          "heading": "8. Haftungsausschluss & Haftungsbeschränkung",
          "body": "Der Dienst wird „wie besehen“ ohne Gewährleistungen jeglicher Art bereitgestellt. Im größtmöglichen gesetzlich zulässigen Umfang ist die Gesamthaftung von FreeCRM auf die in den zwölf Monaten vor dem Anspruch gezahlten Gebühren begrenzt."
        },
        {
          "heading": "9. Anwendbares Recht",
          "body": "Diese Vereinbarung unterliegt den Gesetzen des Staates Delaware, USA, ungeachtet der Kollisionsnormen."
        }
      ]
    },
    "security": {
      "title": "Sicherheit",
      "eyebrow": "Vertrauen",
      "description": "Wie FreeCRM Ihre Daten schützt – basierend auf Amazon AWS mit Verschlüsselung, 24/7-Überwachung und strengen Zugriffskontrollen.",
      "intro": "Wir nehmen Datensicherheit ernst. FreeCRM wird auf Amazon AWS betrieben, mit einer angestrebten Verfügbarkeit von sechs Neunen (99,9999 %) und Ingenieuren, die 24/7/365 im Einsatz sind.",
      "sections": [
        {
          "heading": "Infrastruktur",
          "body": "FreeCRM läuft auf Amazon AWS. Unsere physischen Einrichtungen erfüllen oder übertreffen alle nationalen und internationalen Anforderungen an Datensicherheit, Redundanz, Geschäftsfortführung und Kontinuität."
        },
        {
          "heading": "Verschlüsselung",
          "body": "Alle Daten werden während der Übertragung mit TLS 1.2+ und im Ruhezustand mit AES-256 verschlüsselt. Backups werden verschlüsselt und über mehrere Verfügbarkeitszonen hinweg gespeichert."
        },
        {
          "heading": "Zugriffskontrollen",
          "body": "Rollenbasierter Zugriff innerhalb der Anwendung, Prinzip der geringsten Rechte für den Produktionszugriff und Audit-Protokollierung administrativer Aktionen. Enterprise-Kunden erhalten SSO (SAML), SCIM-Bereitstellung und vollständige Audit-Logs."
        },
        {
          "heading": "Überwachung & Reaktion",
          "body": "24/7/365 Überwachung der Plattform, automatische Benachrichtigung und ein Bereitschaftsteam von Ingenieuren. Wir testen Backups regelmäßig und führen periodische Notfallübungen durch."
        },
        {
          "heading": "Meldung einer Schwachstelle",
          "body": "Senden Sie eine E-Mail an security@freecrm.com mit Details. Wir bestätigen Meldungen innerhalb von 24 Stunden und würdigen eine verantwortungsvolle Offenlegung."
        }
      ]
    },
    "dpa": {
      "title": "Datenverarbeitungsvereinbarung",
      "eyebrow": "Rechtliches",
      "description": "Der DPA regelt, wie FreeCRM personenbezogene Daten im Auftrag von Kunden verarbeitet, in Übereinstimmung mit der DSGVO und ähnlichen Gesetzen.",
      "intro": "Diese Datenverarbeitungsvereinbarung (DPA) ergänzt Ihre FreeCRM-Abonnementvereinbarung und regelt, wie wir personenbezogene Daten in Ihrem Namen verarbeiten.",
      "sections": [
        {
          "heading": "1. Rollen",
          "body": "Sie (Kunde) sind der Datenverantwortliche. FreeCRM fungiert als Datenverarbeiter und verarbeitet personenbezogene Daten nur gemäß Ihren dokumentierten Anweisungen, einschließlich Übertragungen, es sei denn, dies ist durch geltendes Recht vorgeschrieben."
        },
        {
          "heading": "2. Gegenstand und Dauer",
          "body": "Gegenstand: die Bereitstellung des FreeCRM-Dienstes. Dauer: die Laufzeit der Vereinbarung plus etwaige Aufbewahrungsfristen nach Beendigung."
        },
        {
          "heading": "3. Unterauftragsverarbeiter",
          "body": "Wir beauftragen geprüfte Unterauftragsverarbeiter (einschließlich AWS für Hosting und unsere Telefonieanbieter für Sprach- und SMS-Dienste). Eine aktuelle Liste ist auf Anfrage erhältlich. Wir benachrichtigen Kunden über wesentliche Änderungen."
        },
        {
          "heading": "4. Sicherheitsmaßnahmen",
          "body": "Wir setzen technische und organisatorische Maßnahmen ein, die dem Risiko angemessen sind, einschließlich Verschlüsselung während der Übertragung und im Ruhezustand, Zugriffskontrollen, Protokollierung, Schwachstellenmanagement und Personalschulungen."
        },
        {
          "heading": "5. Rechte der betroffenen Personen",
          "body": "Wir unterstützen Sie bei der Erfüllung von Anfragen betroffener Personen (Zugriff, Berichtigung, Löschung, Portabilität) durch In-App-Tools und, falls erforderlich, Support."
        },
        {
          "heading": "6. Internationale Transfers",
          "body": "Sofern personenbezogene Daten außerhalb des EWR, des Vereinigten Königreichs oder der Schweiz übertragen werden, erfolgt die Übertragung gemäß Standardvertragsklauseln oder einem anderen rechtmäßigen Übertragungsmechanismus."
        },
        {
          "heading": "7. Benachrichtigung bei Datenschutzverletzungen",
          "body": "Wir werden Sie unverzüglich benachrichtigen, nachdem wir Kenntnis von einer personenbezogenen Datenschutzverletzung erhalten haben, die Ihre Daten betrifft."
        },
        {
          "heading": "8. Audits",
          "body": "Auf angemessene Benachrichtigung hin stellen wir die erforderlichen Informationen zur Verfügung, um die Einhaltung zu demonstrieren, einschließlich der Berichte Dritter, sofern zutreffend."
        }
      ]
    },
    "industriesIndex": {
      "title": "FreeCRM nach Branchen",
      "eyebrow": "Branchen",
      "description": "Erfahren Sie, wie Teams in Call Centern, Versicherungen, Immobilien, Zahnarztpraxen, professionellen Dienstleistungen und mehr FreeCRM nutzen.",
      "intro": "Vorlagen und Workflows für die Branchen, die auf FreeCRM laufen."
    }
  }
};

export default de;
